import React from 'react';
import { withTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import clsx from 'clsx';
import Label from '../../components/label';
import styles from './view.scss';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function View(props) {
  const { presenter, open, selectedCountry, countries, t } = props;
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={() => presenter?.onCloseClick()}
      TransitionComponent={Transition}
    >
      <div className={clsx(styles.content, 'country-picker-content')}>
        <div className={clsx(styles.toolbar, 'country-picker-toolbar')}>
          <Label className={clsx(styles.title, 'country-picker-title')} text={t('country.title')} />
        </div>
        <div className={clsx(styles.divider, 'country-picker-toolbar-divider')} />
        <div className={clsx(styles.body, 'country-picker-body')}>
          {selectedCountry && (
            <>
              <div
                className={clsx(styles.listItem, 'country-picker-list-item')}
                key={selectedCountry.name}
                button
                onClick={() => presenter.onCountrySelect(selectedCountry)}
              >
                <Label
                  className={clsx(styles.text, 'country-picker-listitem-text')}
                  text={`${selectedCountry.name} (${selectedCountry.phonePrefix})`}
                />
                <div className={clsx(styles.divider, 'country-picker-listitem-divider')} />
              </div>
            </>
          )}
          {countries?.map((country) => {
            return (
              <>
                <div
                  className={clsx(styles.listItem, 'country-picker-list-item')}
                  key={country.name}
                  button
                  onClick={() => presenter.onCountrySelect(country)}
                >
                  <Label
                    className={clsx(styles.text, 'country-picker-listitem-text')}
                    text={`${country.name} (${country.phonePrefix})`}
                  />
                  <div className={clsx(styles.divider, 'country-picker-listitem-divider')} />
                </div>
              </>
            );
          })}
        </div>
      </div>
    </Dialog>
  );
}
export default withTranslation()(View);
